var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',{staticClass:"box-card"},[_c('div',{staticStyle:{"height":"380px"}},[_c('h4',{staticStyle:{"margin":"20px 0"}},[_vm._v(" # 金额统计 ")]),_c('div',{staticClass:"chart-container",attrs:{"id":"my-canvas"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }